<div style="margin-top:1px;" class="p-grid p-d-flex dialog-page">
    <div class="formgrid grid">
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
            <div class="p-field m-2">
                <label for="code"><span translate>label.code</span></label>
                <input type="text" pInputText id="code" [(ngModel)]="item.code" required [disabled]="!canUpdate"
                    tabindex="1" />
                <small class="p-invalid" *ngIf="submitted && !item.code"><span
                        translate>label.field_code_required</span></small>
            </div>
        </div>

        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
            <label for="name"><span translate>label.name</span></label>
            <input type="text" pInputText id="name" [(ngModel)]="item.name" required [disabled]="!canUpdate"
                tabindex="2" />
            <small class="p-invalid" *ngIf="submitted && !item.name"><span
                    translate>label.field_name_required</span></small>
        </div>
    </div>

    <div class="formgrid grid">
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
            <label for="unitValueA"><span>{{labelUnitValueA}}</span></label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><span translate>label.moneySymbol</span></span>
                <p-inputNumber type="text" pInputText id="unitValueA" [(ngModel)]="item.unitValueA"
                    [disabled]="!canUpdate" [minFractionDigits]="2" tabindex="3" />
            </div>
        </div>
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6" *ngIf="showTaxA">
            <label for="unitValueTaxA"><span>{{labelUnitValueTaxA}}</span></label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><span translate>label.moneySymbol</span></span>
                <p-inputNumber type="text" pInputText id="unitValueTaxA" [(ngModel)]="item.unitValueTaxA"
                    [disabled]="!canUpdate" [minFractionDigits]="2" tabindex="4" />
            </div>
        </div>
    </div>

    <div class="formgrid grid">
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6" *ngIf="showValueB">
            <label for="unitValueB"><span>{{labelUnitValueB}}</span></label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><span translate>label.moneySymbol</span></span>
                <p-inputNumber type="text" pInputText id="unitValueB" [(ngModel)]="item.unitValueB"
                    [disabled]="!canUpdate" [minFractionDigits]="2" tabindex="5" />
            </div>
        </div>
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6" *ngIf="showTaxB">
            <label for="unitValueTaxB"><span>{{labelUnitValueTaxB}}</span></label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><span translate>label.moneySymbol</span></span>
                <p-inputNumber type="text" pInputText id="unitValueTaxB" [(ngModel)]="item.unitValueTaxB"
                    [disabled]="!canUpdate" [minFractionDigits]="2" tabindex="6" />
            </div>
        </div>
    </div>

    <div class="formgrid grid">
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6" *ngIf="showRange">
            <label for="totalRangeValueFrom"><span translate>label.totalRangeValueFrom</span></label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><span translate>label.moneySymbol</span></span>
                <p-inputNumber type="text" pInputText id="totalRangeValueFrom" [(ngModel)]="item.totalRangeValueFrom"
                    [disabled]="!canUpdate" [minFractionDigits]="2" tabindex="7" />
            </div>
        </div>
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6" *ngIf="showRange">
            <label for="totalRangeValueTo"><span translate>label.totalRangeValueTo</span></label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><span translate>label.moneySymbol</span></span>
                <p-inputNumber type="text" pInputText id="totalRangeValueTo" [(ngModel)]="item.totalRangeValueTo"
                    [disabled]="!canUpdate" [minFractionDigits]="2" tabindex="8" />
            </div>
        </div>
    </div>

    <div class="formgrid grid">
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
            <label for="unitValueTaxApp"><span>{{labelUnitValueTaxApp}}</span></label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon" *ngIf="item.isUnitValueTaxAppPercent">%</span>
                <span class="p-inputgroup-addon" *ngIf="!item.isUnitValueTaxAppPercent"><span translate>label.moneySymbol</span></span>
                <p-inputNumber type="text" pInputText id="unitValueTaxApp" [(ngModel)]="item.unitValueTaxApp"
                    [disabled]="!canUpdate" [minFractionDigits]="2" tabindex="9" />
            </div>
            <input type="checkbox" id="isUnitValueTaxAppPercent" [(ngModel)]="item.isUnitValueTaxAppPercent" [disabled]="!canUpdate">
            <label for="isUnitValueTaxAppPercent"><span translate>label.isPercent</span></label>
        </div>
        <div class="field col-12 sm:col-12 md:col-6 lg:col-6 xl:col-6">
            <label for="unitValueTaxPay"><span>{{labelUnitValueTaxPay}}</span></label>
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon" *ngIf="item.isUnitValueTaxPayPercent">%</span>
                <span class="p-inputgroup-addon" *ngIf="!item.isUnitValueTaxPayPercent"><span translate>label.moneySymbol</span></span>
                <p-inputNumber type="text" pInputText id="unitValueTaxPay" [(ngModel)]="item.unitValueTaxPay"
                    [disabled]="!canUpdate" [minFractionDigits]="2" tabindex="10" />
            </div>
            <input type="checkbox" id="isUnitValueTaxPayPercent" [(ngModel)]="item.isUnitValueTaxPayPercent" [disabled]="!canUpdate">
            <label for="isUnitValueTaxPayPercent"><span translate>label.isPercent</span></label>
        </div>
    </div>
</div>

<div style="float: right; display: flex; align-items: flex-end; gap: 8px;">
    <button pButton pRipple icon="pi pi-times" style="width: 110px; margin: 3px;" class="p-button-danger p-mr-2 mt-3"
        [label]="'button.cancel' | translate" (click)="hideDialog()"></button>
    <button pButton pRipple icon="pi pi-check" style="width: 110px; margin: 3px;" class="p-button-success p-mr-2 mt-3"
        [label]="'button.confirm' | translate" (click)="saveItem()"></button>
</div>

